import { createWebHistory, createRouter } from "vue-router";
import Inicio from "../pages/Inicio.vue";
import Oportunidades from "../pages/Oportunidades.vue";
import Questionario from "../pages/Questionario.vue";
import Administrativo from "../pages/Administrativo.vue";
import keycloak from "../keycloak";
// Função para verificar se o usuário está autenticado
function isAuthenticated() {
    return keycloak.authenticated;  // Verifica a autenticação no Keycloak
  }

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: "/",
      component: Inicio,
    },
    {
      path: "/inicio",
      component: Inicio,
    },
    {
      path: "/oportunidades",
      component: Oportunidades,
    },
    {
      path: "/questionario",
      component: Questionario,
      meta: { requiresAuth: true }
    },
    {
      path: "/administrativo",
      component: Administrativo,
      meta: { requiresAuth: true, administrativo: true }
    },
  ],
});

router.beforeEach((to, from, next) => {
  // Verifica se a rota requer autenticação
    if (to.meta.requiresAuth && !isAuthenticated()) {
      // Se não estiver autenticado, redireciona para o login do Keycloak
      keycloak.login();
    } 
    if (to.meta.administrativo) {
      const roles = keycloak.tokenParsed?.resource_access?.["vue-app"]?.roles || [];
  
      if (roles.includes('administrativo')) {
        next();
        window.scrollTo(0, 0);
      } else {
        next('/'); // ou uma rota de "Acesso Negado"
        window.scrollTo(0, 0);
      }
    } else {
      next();
      window.scrollTo(0, 0);
    }
});

export default router;